import React from 'react'
import { Link } from 'react-router-dom'

export const Footer = () => {
  return (
    <div className="footer-menu d-column-flex justify-content-center">
      {/* <NavigationMenu className="d-none d-md-flex col-12 col-lg-6 px-1 px-sm-4 px-lg-0" white={true} /> */}
      <div className="row d-column-flex justify-content-center align-items-center">
        <div className="d-flex justify-content-center align-items-center col-12">
          <Link to="/legal/terms-of-service" target="_blank" className="me-4">
            Terms of Service
          </Link>
          <Link to="/legal/privacy-policy" target="_blank" className="me-4">
            Privacy Policy
          </Link>
          {/* <Link to="/legal/music-contributor-agreement" target="_blank">
                        Music Contributor Agreement</Link> */}
        </div>
      </div>
    </div>
  )
}
